import moment from 'moment';

import { CLEAR_HISTORY_TIMESTAMP_LOCAL_STORAGE_KEY } from '../../initialiser/constants';
import {
  SEND_MESSAGE,
  RECEIVE_SENT_MESSAGE,
  RECEIVE_MESSAGE,
  RECEIVE_UNREAD_MESSAGE,
  LOAD_PREVIOUS_ACTIVITIES_FAILED,
  LOAD_PREVIOUS_ACTIVITIES,
  LOAD_PREVIOUS_ACTIVITIES_SUCCESS,
  CLEAR_HISTORY,
  READ_UNREAD_MESSAGES
} from './actions';

const initialState = {
  isFetchingPreviousActivities: false,
  activities: [],
  unreadActivities: [],
  clientActivityBase: `${Date.now().toString()}${Math.random()
    .toString()
    .substr(1)}.`,
  clientActivityCounter: 0,
  selectedActivity: null,
  paginationData: {
    hasNext: false,
    skip: 0
  }
};

const copyArrayWithUpdatedItem = (array, i, item) => [
  ...array.slice(0, i),
  item,
  ...array.slice(i + 1)
];

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PREVIOUS_ACTIVITIES_FAILED: {
      return {
        ...state,
        isFetchingPreviousActivities: false
      };
    }
    case LOAD_PREVIOUS_ACTIVITIES: {
      return {
        ...state,
        isFetchingPreviousActivities: true
      };
    }
    case LOAD_PREVIOUS_ACTIVITIES_SUCCESS: {
      const previousActivities = [...action.activities];

      if (state.paginationData.skip > 0) {
        previousActivities[previousActivities.length - 1] = {
          ...previousActivities[previousActivities.length - 1],
          scrollIntoView: true
        };
      }

      return {
        ...state,
        paginationData: {
          ...state.paginationData,
          ...action.paginationData
        },
        activities: [...previousActivities, ...state.activities],
        isFetchingPreviousActivities: false
      };
    }
    case RECEIVE_SENT_MESSAGE: {
      if (action.activity.channelData && action.activity.channelData.clientActivityId) {
        const i = state.activities.findIndex(
          activity =>
            activity.channelData &&
            activity.channelData.clientActivityId === action.activity.channelData.clientActivityId
        );
        if (i !== -1) {
          const activity = state.activities[i];
          return {
            ...state,
            activities: copyArrayWithUpdatedItem(state.activities, i, activity),
            selectedActivity:
              state.selectedActivity === activity ? action.activity : state.selectedActivity
          };
        }
      }
      // else fall through and treat this as a new message
    }
    // eslint-disable-next-line
    case RECEIVE_MESSAGE:
      // don't allow duplicate messages
      if (state.activities.find(a => a.id === action.activity.id)) return state;

      return {
        ...state,
        activities: [
          ...state.activities.filter(activity => activity.type !== 'typing'),
          action.activity,
          ...state.activities.filter(
            activity => activity.from.id !== action.activity.from.id && activity.type === 'typing'
          )
        ]
      };
    case RECEIVE_UNREAD_MESSAGE:
      return {
        ...state,
        unreadActivities: [...state.unreadActivities, action.activityId]
      };
    case READ_UNREAD_MESSAGES:
      return {
        ...state,
        unreadActivities: []
      };
    case SEND_MESSAGE:
      return {
        ...state,
        activities: [
          ...state.activities.filter(activity => activity.type !== 'typing'),
          {
            ...action.activity,
            timestamp: new Date().toISOString(),
            channelData: {
              clientActivityId: state.clientActivityBase + state.clientActivityCounter
            }
          },
          ...state.activities.filter(activity => activity.type === 'typing')
        ],
        clientActivityCounter: state.clientActivityCounter + 1
      };
    case 'Send_Message_Retry': {
      const activity = state.activities.find(
        activity =>
          activity.channelData && activity.channelData.clientActivityId === action.clientActivityId
      );
      const newActivity = activity.id === undefined ? activity : { ...activity, id: undefined };
      return {
        ...state,
        activities: [
          ...state.activities.filter(
            activityT => activityT.type !== 'typing' && activityT !== activity
          ),
          newActivity,
          ...state.activities.filter(activity => activity.type === 'typing')
        ],
        selectedActivity: state.selectedActivity === activity ? newActivity : state.selectedActivity
      };
    }
    case 'Send_Message_Succeed':
    case 'Send_Message_Fail': {
      const i = state.activities.findIndex(
        activity =>
          activity.channelData && activity.channelData.clientActivityId === action.clientActivityId
      );
      if (i === -1) return state;

      const activity = state.activities[i];
      if (activity.id && activity.id !== 'retry') return state;

      const newActivity = {
        ...activity,
        id: action.type === 'Send_Message_Succeed' ? action.id : null
      };
      return {
        ...state,
        activities: copyArrayWithUpdatedItem(state.activities, i, newActivity),
        clientActivityCounter: state.clientActivityCounter + 1,
        selectedActivity: state.selectedActivity === activity ? newActivity : state.selectedActivity
      };
    }
    case 'SHOW_TYPING':
      return {
        ...state,
        activities: [
          ...state.activities.filter(activity => activity.type !== 'typing'),
          ...state.activities.filter(
            activity => activity.from.id !== action.activity.from.id && activity.type === 'typing'
          ),
          action.activity
        ]
      };

    case 'CLEAR_TYPING':
      return {
        ...state,
        activities: [...state.activities.filter(activity => activity.type !== 'typing')]
      };

    case 'Select_Activity':
      if (action.selectedActivity === state.selectedActivity) return state;
      return {
        ...state,
        selectedActivity: action.selectedActivity
      };

    case 'Take_SuggestedAction': {
      const i = state.activities.findIndex(activity => activity === action.message);
      const activity = state.activities[i];
      const newActivity = {
        ...activity,
        suggestedActions: undefined
      };
      return {
        ...state,
        activities: copyArrayWithUpdatedItem(state.activities, i, newActivity),
        selectedActivity: state.selectedActivity === activity ? newActivity : state.selectedActivity
      };
    }

    case 'Take_QuickReply': {
      const i = state.activities.findIndex(activity => activity === action.message);
      const activity = state.activities[i];
      const { channelData, ...newActivity } = activity;

      return {
        ...state,
        activities: copyArrayWithUpdatedItem(state.activities, i, newActivity),
        selectedActivity: state.selectedActivity === activity ? newActivity : state.selectedActivity
      };
    }

    case CLEAR_HISTORY: {
      // sets the latest time as the clear history
      const date = moment();
      window.localStorage.setItem(CLEAR_HISTORY_TIMESTAMP_LOCAL_STORAGE_KEY, date.toISOString());
      return {
        ...initialState
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/history/reducer.js